import Vue from 'vue'

class SwipeUp {
    constructor(el, binding) {
        if (binding.value) {
            this.binding = binding;
            this.obj = el;
            this.scrollClass = binding.value.scrollClass
            this.vueTouches = { x: 0, y: 0, pageX: 0, clientY: 0 };
            this.curScrollY = 0; //距离底部的距离
            this.scroll50Flag = false; //上拉效果的距离
            this.time = "";

            this.obj.addEventListener("touchstart", (e) => {
                this.start(e);
            }, false);
            this.obj.addEventListener("touchend", (e) => {
                this.end(e);
            }, false);
            this.obj.addEventListener("touchmove", (e) => {
                this.move(e);
            }, false);
        }
    }

    start(e) {
        this.vueTouches = {
            clientY: e.changedTouches[0].clientY
        }
        //防止在底部上拉时候，无法下拉
    }

    move(e) {
        
    }

    end(e) {
        let clientY = e.changedTouches[0].clientY
        let document = e.view.document
        let scrollClass = document.querySelector(this.scrollClass)
        scrollClass.style.transition = "none";
        // 添加过渡效果

        let scrollHeight = this.obj.scrollHeight
        let scrollTop = this.obj.scrollTop;
        localStorage.setItem("scrollTop", scrollTop)
        let clientHeight = this.obj.clientHeight

        this.curScrollY = scrollHeight - (scrollTop + clientHeight)
        if (this.curScrollY <= 20) {
            if (this.binding && this.binding.value && typeof this.binding.value.fn == "function") {
                this.binding.value.fn(scrollClass)
            }
        }
    }

    // move(e) {
    //     // 为了清除卡顿问题，需要清除过渡效果
    //     let document = e.view.document
    //     let scrollClass = document.querySelector(this.scrollClass)
    //     scrollClass.style.transition = "none";
    //     clearTimeout(this.time)

    //     let scrollHeight = this.obj.scrollHeight
    //     let scrollTop = this.obj.scrollTop;
    //     let clientHeight = this.obj.clientHeight

    //     this.curScrollY = scrollHeight - (scrollTop + clientHeight)
    //     if (this.curScrollY == 0) {
    //         //获取translateY的高度
    //         var translates =
    //             document.defaultView.getComputedStyle(scrollClass, null).transform;
    //         let scorllY = translates.substring(22)
    //         scorllY = scorllY.substring(0, scorllY.length - 1)
    //         if (parseInt(scorllY) < -50) {
    //             this.scroll50Flag = true
    //             return
    //         }
    //         let clientY = e.changedTouches[0].clientY
    //         const y = clientY - this.vueTouches.clientY;
    //         // 阻尼系数0.5
    //         scrollClass.style.transform = 'translateY(' + 0.3 * y + 'px)';
    //     }
    // }

    // end(e) {
    //     let document = e.view.document
    //     let scrollClass = document.querySelector(this.scrollClass)
    //     scrollClass.style.transition = "none";
    //     // 添加过渡效果

    //     let scrollHeight = this.obj.scrollHeight
    //     let scrollTop = this.obj.scrollTop;
    //     let clientHeight = this.obj.clientHeight

    //     this.curScrollY = scrollHeight - (scrollTop + clientHeight)
    //     if (this.curScrollY == 0) {
    //         if (!this.scroll50Flag) {
    //             scrollClass.style.transition = "none";
    //             scrollClass.style.transition = 'transform .3s';
    //             scrollClass.style.transform = 'translateY(' + 0 + 'px)';
    //             this.scroll50Flag = false
    //         }
    //         if (this.binding && this.binding.value && typeof this.binding.value.fn == "function") {
    //             //获取translateY的高度
    //             var translates =
    //                 document.defaultView.getComputedStyle(scrollClass, null).transform;
    //             let scorllY = translates.substring(22)
    //             scorllY = scorllY.substring(0, scorllY.length - 1)
    //             if (parseInt(scorllY) > -50) {
    //                 this.scroll50Flag = false
    //                 scrollClass.style.transition = "none";
    //                 scrollClass.style.transition = 'transform 0s';
    //                 scrollClass.style.transform = 'translateY(' + 0 + 'px)';
    //             } else {
    //                 setTimeout(() => {
    //                     this.binding.value.fn(scrollClass)
    //                 }, 600)
    //             }
    //         }
    //     } else {
    //         scrollClass.style.transition = "none";
    //         scrollClass.style.transition = 'transform 0.3s';
    //         scrollClass.style.transform = 'translateY(' + 0 + 'px)';
    //         this.scroll50Flag = false
    //     }
    // }
};

Vue.directive("swipeup", {
    bind: function (el, binding) {
        new SwipeUp(el, binding);
    }
});


// WEBPACK FOOTER //
// ./src/utils/touch.js